import { memo } from 'react';
import BaseMenuItem from '../../../Shared/Table/widgets/TopBar/MenuItem/BaseMenuItem';
import { useSelector } from 'react-redux';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

const AddButton = memo(({ label, onClick }) => {
  const { en: { btn } } = useSelector((state) => state.i18n);

  return <BaseMenuItem
    icon={<AddCircleOutlineIcon
      style={{ stroke: '#ffffff', strokeWidth: .4, height: 26, width: 26 }}
    />}
    label={btn.create + ' ' + label}
    onClick={onClick}
    buttonAlign={'flex-start'}
  />;
});

export default AddButton;
